import UserManagement from './UserManagement.vue'

export default UserManagement


// WEBPACK FOOTER //
// ./src/pages/UserManagement/index.js